import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import Card from 'react-bootstrap/Card';
import Notifications, { notify } from 'react-notify-toast';
import { BottomNav, Sidebar, LazyLoader } from "../../index";

function Dashboard() {

  const authObj = useSelector(state => state.auth);
  const { superAdmin: { user } } = authObj;
  const [userName, setUserName] = useState('');
  const [loader, setLoader] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const toggleMenu = (value) => {
    setOpenMenu(value);
  };

  useEffect(() => {
    const { firstName, lastName } = JSON.parse(
      localStorage.getItem('loggedInUserData')
    );
    setUserName(firstName + ' ' + lastName);
  }, []);

  return (
    < div className="su-dashboard pl-4 pr-4 pb-5" >
      <h6 className="text-black-50 pt-5 small">Hey! Welcome</h6>
      <h5 className="text-capitalize">{userName}</h5>
    </div >

  );
}

export default Dashboard;
